/*
 * Custom JavaScript
 * ===========================================================================
 *
 * Use this file to add your own custom JavaScript code.
 *
 * This file is loaded at the end of the body with the 'defer' attribute,
 * which means it will execute after the HTML document has been parsed.
 *
 * Tips:
 * - The DOM is ready when this script runs (no need for DOMContentLoaded)
 * - You can use Shopify's global objects like:
 *   - window.Shopify - Shopify global object with shop info
 *   - window.routes - Cart and search URLs
 *   - window.cartStrings - Cart-related translation strings
 *   - window.variantStrings - Product variant translation strings
 *
 * - The theme uses a pub/sub pattern for events. You can subscribe to events:
 *   - subscribe(PUB_SUB_EVENTS.cartUpdate, callback) - Cart updates
 *   - subscribe(PUB_SUB_EVENTS.quantityUpdate, callback) - Quantity changes
 *
 * - Common DOM queries:
 *   - document.querySelector('.selector') - Get single element
 *   - document.querySelectorAll('.selector') - Get all matching elements
 *
 * ===========================================================================
 */

/* Add your custom JavaScript below this line */

/* ---------------------------------------------------------------------------
 * « Comment avez-vous découvert Nook-It ? » (ajout du 28/09/2026)
 * Question facultative affichée au-dessus du bouton de validation du panier
 * (tiroir Essential Cart Drawer et page /cart). La réponse est enregistrée
 * comme attribut du panier, qui se retrouve sur la commande :
 * Commande > Informations supplémentaires > « Source déclarée ».
 * Aucun cookie, aucun envoi à un tiers : c'est le client qui répond.
 * ------------------------------------------------------------------------- */
(function () {
  var KEY = 'Source déclarée';
  var CHOICES = ['Sur Google', 'Instagram ou Facebook', 'TikTok', 'Un proche', 'Autre'];
  var current = null;

  var css =
    '.nk-src{margin:0 0 12px;padding:10px 12px;border:1px solid rgba(155,72,34,.25);border-radius:10px;background:rgba(155,72,34,.04);font-size:13px;line-height:1.3}' +
    '#cart-drawer .nk-src{margin:0 20px 12px}' +
    '.nk-src__q{margin:0 0 8px;font-weight:600;color:#3a2a20}' +
    '.nk-src__q span{font-weight:400;opacity:.7}' +
    '.nk-src__list{display:flex;flex-wrap:wrap;gap:6px}' +
    '.nk-src__btn{appearance:none;cursor:pointer;font:inherit;font-size:12.5px;padding:5px 10px;border-radius:999px;border:1px solid rgba(155,72,34,.45);background:#fff;color:#3a2a20;min-height:30px}' +
    '.nk-src__btn[aria-pressed="true"]{background:rgb(155,72,34);border-color:rgb(155,72,34);color:#fff}' +
    '.nk-src__ok{margin:6px 0 0;font-size:12px;color:rgb(155,72,34);min-height:1em}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function save(value) {
    current = value;
    refreshAll();
    var attrs = {};
    attrs[KEY] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'nk-src';
    box.setAttribute('data-nk-src', '');
    var q = document.createElement('p');
    q.className = 'nk-src__q';
    q.id = 'nk-src-q-' + Math.random().toString(36).slice(2, 7);
    q.innerHTML = 'Comment avez-vous découvert Nook-It ? <span>(facultatif)</span>';
    var list = document.createElement('div');
    list.className = 'nk-src__list';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-labelledby', q.id);
    CHOICES.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nk-src__btn';
      b.textContent = c;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        save(c);
      });
      list.appendChild(b);
    });
    var ok = document.createElement('p');
    ok.className = 'nk-src__ok';
    ok.setAttribute('aria-live', 'polite');
    box.appendChild(q);
    box.appendChild(list);
    box.appendChild(ok);
    refresh(box);
    return box;
  }

  function refresh(box) {
    box.querySelectorAll('.nk-src__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.textContent === current));
    });
    box.querySelector('.nk-src__ok').textContent = current ? 'Merci !' : '';
  }

  function refreshAll() {
    document.querySelectorAll('[data-nk-src]').forEach(refresh);
  }

  function mount() {
    // Tiroir panier (Essential Cart Drawer)
    var drawer = document.querySelector('[data-essential-cart-element="checkout-button-wrapper"]');
    if (drawer && !(drawer.previousElementSibling && drawer.previousElementSibling.hasAttribute('data-nk-src'))) {
      drawer.parentNode.insertBefore(build(), drawer);
    }
    // Page panier du thème (et tiroir d'origine du thème, s'il est réactivé)
    document.querySelectorAll('.cart__ctas').forEach(function (anchor) {
      if (!anchor.querySelector('[name="checkout"]')) return;
      if (!(anchor.previousElementSibling && anchor.previousElementSibling.hasAttribute('data-nk-src'))) {
        anchor.parentNode.insertBefore(build(), anchor);
      }
    });
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.attributes && cart.attributes[KEY]) current = cart.attributes[KEY];
      refreshAll();
    })
    .catch(function () {});

  // Le tiroir est redessiné à chaque ouverture : on replace la question si besoin.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; mount(); }, 50);
  }).observe(document.body, { childList: true, subtree: true });
  mount();
})();
